import { Component, Input } from '@angular/core';
import { SLEntity } from '../entity';

@Component({
  selector: 'sl-entity-infos',
  templateUrl: './entity-infos.component.html',
})
export class SLEntityInfosComponent {

  @Input()
  entity: SLEntity
}
